'use strict'
import $ from 'jquery'
import axios from 'axios'
import toastr from '../../../plugins/toastr2'
import product from './supplierItemProduct'
import Api from './api'

const extraFields = window.extraFields
const extraFieldsOptions = window.extraFieldsOptions
const api = new Api()

export default class SupplierItem {

    constructor(id) {
        this.id = id
        const time = performance.now()
        this.form = document.querySelector(`[data-supplier-item-id="${this.id}"]`)
        this.productType = this.form.querySelector('[name="product_type_id"]')
        this.manufacturer = this.form.querySelector('[name="manufacturer_id"]')
        this.model = this.form.querySelector('[name="model_id"]')
        this.extraFields = this.form.querySelector('.supplier-item__extrafields .row')
        this.productBlock = this.form.querySelector('[data-product-id]')
        let productData = JSON.parse(this.form.getAttribute('data-product'));

        if (this.productTypeId) {
            this.setManufacturersList()
        }

        if (productData) {
            this.initializeProduct(productData)
        }

        window.massActions = this.massActions
        this.initializeEvents()
    }

    initializeProduct(productData) {
        this.product = new product(productData, this.productBlock, this.id)
    }

    initializeEvents() {
        this.productType.addEventListener('change', (event) => {
            console.log('Тип продукта изменен – загружены характеристики')
            let productTypeId = this.productTypeId
            this.setManufacturersList(productTypeId)
            this.updateModelsList()
            this.setExtraFields(productTypeId)
        })

        $(this.manufacturer).on('change', () =>  {
            this.updateModelsList()
            if ($(this.manufacturer).val() !== $(this.manufacturer).data('selectedId')) {
                this.save()
            }
        })

        $(this.model).on('change', () => {
            this.updateExtraFieldValuesFromModel()
            if (this.modelId !== JSON.parse(this.model.getAttribute('selectedId'))) {
                this.save()
            }
        })

        this.form.addEventListener('change', (event) => {
            this.save()
        })

        if (this.manufacturerId) {
            this.updateModelsList()
        }

    }

    updateModelsList() {
        if (this.manufacturerId) {
            api.getManufacturerModels(this.manufacturerId).then(response => {
                let models = response.data
                this.setList(this.model, models, 'name', 'id')
                this.updateExtraFieldValuesFromModel()
            })
        }
    }

    debug() {
        return true
    }

    save() {
        let action = this.form.getAttribute('action'),
            method = this.form.querySelector('[name=_method]').value,
            data = $(this.form).serialize()
        axios
            .request({
                url: action,
                method: method,
                data: data,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                }
            })
            .then((response) => {


                let data = response.data

                console.log('SupplierItemController response', data);

                if (data.flashMessages) {
                    data.flashMessages.forEach(function (item) {
                        if (item.type && item.text) {
                            toastr[item.type](item.text)
                        }
                    })
                }

                if (data.product) {
                    this.initializeProduct(data.product)
                } else {
                    this.removeProduct()
                }

            })
            .catch(function (error) {
                toastr['warning']('[js] SupplierItem@save failed')
                // alert(error.message)
                if (error.response) {
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)
                } else if (error.request) {
                    console.log(error.request)
                } else {
                    console.log(error)
                    console.log('Error', error.message)
                }
                console.log('----------------------------------------------------------')
            })
            .then(function () {
            })
    }

    massActions(identifier) {
        let elements = $(identifier)
        let first = elements.first()
        let value = elements.first().val()
        elements.val(value)
    }

    removeProduct() {

        if (this.debug()) {
            console.log('removeProduct')
        }
        this.form.querySelector('[data-product-name]').innerHTML = 'Товар отсутствует'

        const dataImageWrapper = this.form.querySelector('[data-image-wrapper]')

        if (dataImageWrapper) {
            dataImageWrapper.innerHTML = ''
        }

        const dataImageEditor = this.form.querySelector('[data-image-editor]')

        if (dataImageEditor) {
            dataImageEditor.innerHTML = ''
        }
    }

    setExtraFieldValueId(fieldId, valueId) {
        let elem = this.form.querySelector('[name="extra_fields[' + fieldId + ']"]')
        if (elem) {
            elem.value = valueId
        }
    }

    isEnoughForTyresIndexesRequest() {
        if (this.productTypeId === 172
            && this.manufacturerId
            && this.modelId) {

        }
    }

    setExtraFields(productTypeId) {
        console.log('setExtraField for ptid: ' + this.productTypeId + ' siid:' + this.id)

        let extraFieldsList = extraFields[productTypeId]

        let btns = this.extraFields.querySelector('.js-control-btns').cloneNode();
        this.extraFields.innerHTML = ''

        for (let extraFieldId in extraFieldsList) {

            if (extraFieldsList.hasOwnProperty(extraFieldId)) {
                const data = document.createElement('div')
                data.classList.add('col-lg-2', 'order-0')
                const formGroup = document.createElement('div')
                formGroup.classList.add('form-group')
                const labelFormGroup = document.createElement('label')
                labelFormGroup.innerText = extraFieldsList[extraFieldId]

                const select = document.createElement('select')
                select.setAttribute('data-placeholder', '~')
                select.classList.add('form-control', 'js-chosen-not-inited')
                select.name = `extra_fields[${extraFieldId}]`

                let extraFieldsOptionsList = extraFieldsOptions[extraFieldId]
                const _option = document.createElement('option')
                select.appendChild(_option)
                for (let optionId in extraFieldsOptionsList) {
                    if (extraFieldsOptionsList.hasOwnProperty(optionId)) {
                        const option = document.createElement('option')
                        option.value = optionId
                        option.innerText = extraFieldsOptionsList[optionId]
                        select.appendChild(option)
                    }
                }
                formGroup.appendChild(labelFormGroup)
                formGroup.appendChild(select)
                data.appendChild(formGroup)
                this.extraFields.appendChild(data)
            }

        }
        $('.js-chosen-not-inited')
            .removeClass('js-chosen-not-inited')
            .addClass('chosen-select')
            .chosen()

        this.extraFields.appendChild(btns)

    }

    updateExtraFieldValuesFromModel() {
        if (this.modelId) {

            api.getModel(this.modelId).then(response => {
                let extraFieldsForModelsList = response.data.extraFieldsForModelsList

                for (let fieldId in extraFieldsForModelsList) {
                    let valueId = extraFieldsForModelsList[fieldId]
                    this.setExtraFieldValueId(fieldId, valueId)
                }
            })
        }
    }

    getExtraFieldValueId(fieldId) {
        return ('[name="extra_fields[' + fieldId + ']"]').value
    }

    get modelId() {
        return this.model.value
    }

    get productTypeId() {
        return this.productType.value
    }

    get productTypeName() {
        return this.productType.innerText
    }

    get manufacturerId() {
        return $(this.manufacturer).val() || $(this.manufacturer).data('selectedId')
    }

    get manufacturerName() {
        return this.manufacturer.innerText
    }

    setManufacturersList() {
        api.getManufacturersGroupedByType().then(response => {
            let manufacturers = response.data
            this.setList($(this.manufacturer), manufacturers[this.productTypeId])
        }).then(this.updateModelsList())
    }

    setList(element, list, nameKey = null, idKey = null) {
        let _element = $(element)
        _element.empty()
        if (list) {
            let options = this.generateOptionsList(list, nameKey, idKey)
            _element.append(options)
        }

        let selectedId = _element.data('selectedId')

        if (selectedId) {
            _element.val(selectedId)
        }
        _element.trigger('chosen:updated')
    }

    generateOptionsList(array, nameKey = null, idKey = null) {
        let list = '<option></option>',
            name,
            id
        for (let i in array) {
            name = ''
            if (array.hasOwnProperty(i)) {
                if (nameKey && array[i].hasOwnProperty(nameKey)) {
                    name = array[i][nameKey]
                } else {
                    name = array[i]
                }
                if (idKey && array[i].hasOwnProperty(idKey)) {
                    id = array[i][idKey]
                } else {
                    id = i
                }

                if (typeof id === "string") {
                    id = Number(id.replace(/^"|"$/g, ''));
                }

                list += '<option value="' + id + '">' + name + '</option>'
            }
        }
        return list
    }

    static init() {

        $('[data-supplier-item-id]').each(function (key, value) {
            let element = $(value),
                supplierItemId = element.data('supplierItemId'),
                supplierItem = new SupplierItem(supplierItemId)
        })
    }

}

SupplierItem.init()



